import { log } from 'log';
import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { resetToDefault } from 'js/hooks/user/store/actions';
import { useUserSelector } from 'js/store/hooks';

import * as pas from '../pas';
import * as actions from '../store/actions';
import * as helpers from '../helpers';

export const useLogout = () => {
    const dispatch = useDispatch();
    const sessionToken = useUserSelector(prop('sessionToken'));

    return useCallback(async ({ isQuiet = false, isManual = true } = {}) => {
        dispatch(actions.setIsLogoutManual(isManual));
        dispatch(actions.setIsLogoutInProcess(true));
        dispatch(resetToDefault());

        helpers.removeRememberMeItem();

        // according to google documentation we need to call this method on logout
        window.google?.accounts?.id?.disableAutoSelect();

        try {
            await pas.setLoginType(null);

            if (!isQuiet || sessionToken) {
                // do a regular logout to clear everything, all sessions
                // sessionToken check is needed to do logout in a separate tab
                await pas.logout();
            }
        } catch (err) {
            log('info', err);
        } finally {
            dispatch(actions.setIsLogoutInProcess(false));
        }
    }, [
        dispatch,
        sessionToken
    ]);
};
